import { createSlice } from '@reduxjs/toolkit';
import { getAllConnectionsAction } from 'redux/actions/connection';

const initialState = {
  connectionsLoading: false,
  connections: [],
  loading: false,
};

// First import your thunk then add thunk lifecycle handlers
export const connectionSlice = createSlice({
  name: 'connection',
  initialState,
  reducers: {},
  extraReducers: {
    [getAllConnectionsAction.pending]: (state) => {
      state.loading = true;
    },
    [getAllConnectionsAction.fulfilled]: (state, action) => {
      state.connections = action.payload;
      state.loading = false;
    },
    [getAllConnectionsAction.rejected]: (state) => {
      state.loading = false;
    },
  },
});

// export auto-generated action creators from the reducer
export const actions = connectionSlice.actions;
// export the reducer to be passed to configureStore
export default connectionSlice.reducer;
